import { Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-horizontal-stepper-type',
  template: `
    <mat-horizontal-stepper>
      <mat-step
        *ngFor="let step of field.fieldGroup; let index = index; let last = last;">
        <ng-template matStepLabel>{{ step.templateOptions.label }}</ng-template>
        <formly-field [field]="step"></formly-field>

        <div>
          <button matStepperPrevious *ngIf="index !== 0"
            class="btn btn-primary"
            type="button">
            Back
          </button>

          <button matStepperNext *ngIf="!last"
            class="btn btn-primary" type="button"
            [disabled]="!isValid(step)">
            Next
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
`,
})
export class HorizontalStepperTypeComponent extends FieldType {
  isValid(field: FormlyFieldConfig) {
    if (field.key) {
      return field.formControl.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }
}
